module.exports = __webpack_public_path__ + "img/figure.a4724571.svg";